import React from 'react';
import { formatCurrency } from '../../../core/utils/format';
import { STATUS } from '../../../core/constants/financial';

const BankSummary = ({ banks }) => {
  const activeBanks = banks.filter((b) => b.status === STATUS.ATIVO);
  const inactiveBanks = banks.filter((b) => b.status === STATUS.INATIVO);
  const totalBalance = activeBanks.reduce((sum, b) => sum + (Number(b.balance) || 0), 0);

  return (
    <div className="fd-modal-summary">
      <div className="fd-modal-summary-item">
        <span className="fd-modal-summary-label">Total de Bancos</span>
        <span className="fd-modal-summary-value">{banks.length}</span>
      </div>
      <div className="fd-modal-summary-item">
        <span className="fd-modal-summary-label" style={{ color: '#70E000' }}>Ativos</span>
        <span className="fd-modal-summary-value" style={{ color: '#70E000' }}>{activeBanks.length}</span>
      </div>
      <div className="fd-modal-summary-item">
        <span className="fd-modal-summary-label">Inativos</span>
        <span className="fd-modal-summary-value">{inactiveBanks.length}</span>
      </div>
      <div className="fd-modal-summary-item fd-modal-summary-item--last">
        <span className="fd-modal-summary-label" style={{ color: '#60b4f6' }}>Saldo Total</span>
        <span className="fd-modal-summary-value" style={{ color: '#60b4f6' }}>{formatCurrency(totalBalance)}</span>
      </div>
    </div>
  );
};

export default BankSummary;
